export const REF_NAME = 'PRODUCER';
export const REF_PATH = 'producer';
export const NAME = 'Producer';
